'strict';
require('jquery');

// The handler used to walk every <header> and rewrite its class list on every
// scroll event. Only the two transitions actually change anything, so track the
// applied state and bail otherwise. `passive` tells the browser the handler will
// never preventDefault(), so scrolling is not blocked waiting on it.
let stuck = null;

window.addEventListener('scroll',
  function(e) {
    const next = window.scrollY > 1;
    if (next === stuck) return;
    stuck = next;

    const op = next
      ? function(d) { d.classList.add('sticky'); }
      : function(d) { d.classList.remove('sticky'); };

    // driver.js (interactive tours) also builds its popover title as a
    // <header id="driver-popover-title">, so a blanket tag-name match here
    // hijacks its layout via .sticky's `position: sticky` mid-tour. Skip it.
    for (let elt of document.getElementsByTagName("header")) {
      if (elt.id === "driver-popover-title") continue;
      op(elt);
    }
  },
  { passive: true }
);


/*
 * Replace all SVG images with inline SVG
 * https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
 */
jQuery('img.svg').each(function(){
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', 'replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        $img.wrap(`<span class="${imgClass}"/>`);

        // Replace image with new SVG
        $img.replaceWith($svg);

    }, 'xml');

});
